import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { GetUserResult, UserResetmail, UserResetPasswordResponse, UserValidationChild, UserValidationStatusRespose, XdecryptRequest } from '../models/UserModel';
import { PasswordEmailModel} from '../models/EmailPasswordChangeModel';
import { Contact } from '../models/Contact';
import { SharingService } from 'src/app/modules/shared/shared.service';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    APIURL = environment.apiURL;
    serviceUrl: string;
    setEmailUri: string;
    setPwdUri: string;
    /// private _jsonURL = 'assets/dataMockups/loginMockup.json';
    constructor(private httpClient: HttpClient, private sharingService: SharingService) {
    }

   
    IsValidateUser(userDetails : UserValidationChild): Observable<UserValidationStatusRespose> {

        const uri = this.APIURL + "api/user/validate";
          return this.httpClient.post<UserValidationStatusRespose>(uri,userDetails);
  
      }

    // SendEmailForValidation(request: PasswordEmailModel): Observable<any> {
    //     this.setEmailUri = this.APIURL + "api/user/SendEmailForValidation";
    //     return this.httpClient.post<any>(this.setEmailUri, request);
    // }

    SetEmail(request : PasswordEmailModel): Observable<any> {
        this.setEmailUri = this.APIURL + "api/user/setEmail/set";
        return this.httpClient.post<any>(this.setEmailUri, request,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }

    SetPasswordEmail(request: PasswordEmailModel): Observable<any> {
        this.setPwdUri = this.APIURL + "api/user/passworemail/set";
        return this.httpClient.post<any>(this.setPwdUri, request,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }

    GetUser(username: string ) : Observable<any>
    {
        const uri = `${this.APIURL + "api/user/getuser"}/${username}`;
        return this.httpClient.get<GetUserResult>(uri,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    SendEmail(userResetMail: UserResetmail): Observable<any> {
        const uri = this.APIURL + "api/user/UserResetMail";
        return this.httpClient.post<any>(uri, userResetMail,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    EncryptUserDetails(userDetails: GetUserResult): Observable<any> {
        const uri = this.APIURL + "api/user/EncryptUserDetails";
        return this.httpClient.post<any>(uri, userDetails,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    DecryptUrlParameters(getDecryptDetails: GetUserResult): Observable<any> {
        const uri = this.APIURL + "api/user/DecryptUrlParameters";
        return this.httpClient.post<any>(uri, getDecryptDetails);
    }
    UserResetPassword(userName :string , messageType:string) :  Observable<any>
    {
        const uri = `${this.APIURL + "api/user/userresetpassword"}/${userName}/${messageType}`;
        return this.httpClient.get<UserResetPasswordResponse>(uri,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
   
    IsValidEmail(userResetPasswordResponse : UserResetPasswordResponse)
    {
        const uri =this.APIURL + "api/user/DecryptDetails";
        return this.httpClient.post<UserResetPasswordResponse>(uri,userResetPasswordResponse,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    ChangeUserStatus(getStatusDetails: GetUserResult): Observable<any> {
        const uri = this.APIURL + "api/user/ChangeUserStatus";
        return this.httpClient.post<any>(uri, getStatusDetails,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    GetGenaratedPassword(userName: string) {
        const uri = `${this.APIURL + "api/user/GetGenaratedPassword"}/${userName}`;
        return this.httpClient.get<UserResetPasswordResponse>(uri,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    Xdecrypt(decryptpass :XdecryptRequest)
    {
        const uri = this.APIURL + "api/user/Xdecrypt";
        return this.httpClient.post<any>(uri,decryptpass,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    ChangePassword(passowrdResetModel : PasswordEmailModel)
    {
        const uri =this.APIURL + "api/user/ChangePassword";
        return this.httpClient.post<any>(uri,passowrdResetModel,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    EncryptDetails(encryptData : GetUserResult)
    {
        const uri = this.APIURL + "api/user/EncryptDetails";
        return this.httpClient.post<any>(uri,encryptData,{
            headers: this.sharingService.createAuthorizationHeader()
          });
    }
    GererContact(contact : Contact)
    {
        const uri = this.APIURL + "api/user/GererContact";
    return this.httpClient.post<any>(uri,contact,{
        headers: this.sharingService.createAuthorizationHeader()
      });

    }
}
